import { render, staticRenderFns } from "./KimChokSdnBhdDashboard.vue?vue&type=template&id=ba09f932&scoped=true"
import script from "./KimChokSdnBhdDashboard.vue?vue&type=script&lang=ts"
export * from "./KimChokSdnBhdDashboard.vue?vue&type=script&lang=ts"
import style0 from "./KimChokSdnBhdDashboard.vue?vue&type=style&index=0&id=ba09f932&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba09f932",
  null
  
)

export default component.exports